import { GLServiceBase, ServiceRoute } from "commonui";
import { ILessonPlanActivitiesService } from "./interface";
import {
	LessonPlanActivityReferenceForLPVResponseModel,
	LessonPlanActivityResponseModel,
	LessonPlanActivitySaveEditModel,
	MasterPlanActivityRequestModel,
	MasterPlanActivityResponseModel
} from "./model";

class LessonPlanActvitieServiceClass extends GLServiceBase<any, any> implements ILessonPlanActivitiesService {
	serviceRoute: ServiceRoute = { prefix: "content/v1/activities" };

	getLessonPlanActivities(): Promise<LessonPlanActivityResponseModel[]> {
		return this.get();
	}

	getLessonPlanActivity(activityId: number): Promise<LessonPlanActivityResponseModel> {
		return this.get("{activityId}", null, { activityId });
	}

	saveActivity(model: LessonPlanActivitySaveEditModel): Promise<void> {
		return this.create(model);
	}

	editActivity(model: LessonPlanActivitySaveEditModel, activityId: number): Promise<void> {
		return this.update("{activityId}", model, { activityId });
	}

	getActivityReferenceCountForLPV(activityId: number): Promise<LessonPlanActivityReferenceForLPVResponseModel[]> {
		return this.get("{activityId}/references", null, {
			activityId
		});
	}

	getMasterPlanActivities(lessonPlanVersionId: string, unitId: number): Promise<MasterPlanActivityResponseModel[]> {
		return this.get("lessonplanversion/{lessonPlanVersionId}/unit/{unitId}/masterplan", null, {
			lessonPlanVersionId,
			unitId
		});
	}
}

export const LessonPlanActivitiesService: () => ILessonPlanActivitiesService = () =>
	new LessonPlanActvitieServiceClass();
